import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChallengeIntroPage } from './app-challenge-intro';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChallengeIntroPage,
  ],
    imports: [
        IonicPageModule.forChild(AppChallengeIntroPage),
        PipesModule,
        DirectivesModule,
    ],
})
export class AppChallengeIntroPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-intro/app-challenge-intro.module.ts